// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file Method for building default card table body product breakdown.
 * @author James Reid
 */

// @ts-check

// @@imports-dependencies
import { Bom } from "../../../../../../package/index.js"

// @@body
/**
 * Generate table body element containing a breakdown by line item for similar
 * products within a given category.
 * @param {Bom} bom Bom with line items to be displayed in breakdown table.
 * @returns {HTMLTableSectionElement} Table body element containing product line
 * item breakdown information.
 */
const getDefaultBreakdown = bom => {
    const tableBody = document.createElement("tbody")

    // Add table row for each line item.
    for (const lineItem of bom.lineItems) {
        const row = document.createElement("tr")

        const sku = document.createElement("td")
        sku.innerText = `${lineItem.sku}`

        const name = document.createElement("td")
        name.innerText = lineItem.product.name

        const price = document.createElement("td")
        // price.innerText = `£${lineItem.product.price.toFixed(2)}`
        price.innerText = `£${lineItem.price.toFixed(2)}`
        price.classList.add("--price-detail")

        const quantity = document.createElement("td")
        quantity.innerText = `${lineItem.quantity}`

        // const total = document.createElement("td")
        // total.innerText = `£${lineItem.price.toFixed(2)}`
        // total.classList.add("--price-detail")

        // row.append(sku, name, price, quantity, total)
        row.append(quantity, name, price)
        tableBody.append(row)
    }

    return tableBody
}

// @@exports
export { getDefaultBreakdown }
